import {
  Component,
  OnInit,
  ViewChild,
  ElementRef,
  AfterViewInit,
  DoCheck,
  AfterContentChecked,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { FormGroup, FormControl, ReactiveFormsModule } from '@angular/forms';
//dasboard
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { DashboardService } from '../dashboard.service';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
//api//
import { HttpRequestService } from '../../../common-services/http-request.service';
import * as XLSX from 'xlsx';
//print
import { VERSION } from '@angular/core';
// date
import { DatePipe } from '@angular/common';
import { formatDate } from '@angular/common';

import * as Highcharts from 'highcharts';
import HC_exporting from 'highcharts/modules/exporting';
import { from, of, zip } from 'rxjs';
import { groupBy, mergeMap, toArray } from 'rxjs/operators';
import { AfterContentInit } from '@angular/core';

import * as jspdf from 'jspdf';
import { jsPDF } from 'jspdf';
import html2canvas from 'html2canvas';
import { ExcelService } from 'src/app/common-services/excel.service';
import { Chart } from 'chart.js';

export interface PeriodicElement {
  name: string;
  position: number;
  count: number;
}
//pdf
declare var require: any;
const FileSaver = require('file-saver');

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css'],
  providers: [DatePipe],
})
export class DashboardComponent
  implements OnInit, DoCheck, AfterContentChecked, AfterViewInit {
  bigChart: any;
  pierChartJs: any;
  cards = [];
  pieChart = [];
  userTypeData = [];
  gcUserChart = [];
  lcUserChart = [];
  chartOptions: {};
  PieChartOption: {};
  Highcharts = Highcharts;
  OverallView = [];
  UserTypesOptions: {};
  gcUserOptions: {};
  lcUserOptions: {};
  //date picker//
  startDate: FormGroup;
  endDate: FormGroup;
  //autocomplete//
  myControl = new FormControl();
  options: string[] = ['General Contractor', 'Sub Contractor'];
  filteredOptions: Observable<string[]>;
  //dashboard count//
  count: any;
  general_contractor_count: any;
  project_count: any;
  requisition_count: any;
  requisition_labour_count: any;
  sub_contractor_count: any;
  supply_count: any;
  supply_labour_count: any;
  user_count: any;
  userList: any;
  //dashboard count end
  default_val = null;

  // chart js
  canvas: any;
  ctx: any;
  @ViewChild('mychart') mychart: any;
  @ViewChild('mychart1') mychart1: any;
  @ViewChild('callingActivity') callingActivity: any;

  //changes on selection user change varibale
  gcShow: boolean = false;
  lcShow: boolean = false;
  projectShow: boolean = false;
  supplyShow: boolean = false;
  requisitionShow: boolean = false;

  // company wise title
  companyName: boolean = false;

  // excel
  userAnlyticsData: any;
  userTypeValue = 'General Contractor and  Labor Contractor';
  fileName = 'ExcelSheet.xlsx';
  //print start///
  name = 'Angular ' + VERSION.major;
  title: any;
  requisitionSearchAnalytics: any;
  requisitionLcCalling: any;
  lcProfileVisit: any;
  supplySearchAnalytics: any;
  projectProfileCalling: any;
  onSearch: boolean = true;
  gcSearch: boolean;
  lcSearch: boolean;
  getUserPierCharts = {};
  getUserJs = [];

  getGcLcUserPierCharts = {};
  getGcLcJs = [];

  areaChartOption = {};
  areaChartOptionjs = [];
  printPage() {
    // window.print();

    var element = document.getElementById('table');

    html2canvas(element).then((canvas) => {
      console.log('canvas ', canvas);

      var imgData = canvas.toDataURL('image/png');

      const doc = new jsPDF();

      var imgHeight = (canvas.height * 208) / canvas.width;

      doc.addImage(imgData, 0, 0, 208, imgHeight);
      doc.save('EfORCE-charts.pdf');
    });
  }

  printPage2() {
    window.print();
  }
  //print page end///

  data: any = [{
    eid: 'e101',
    ename: 'ravi',
    esal: 1000
  }, {
    eid: 'e102',
    ename: 'ram',
    esal: 2000
  }, {
    eid: 'e103',
    ename: 'rajesh',
    esal: 3000
  }];

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

  constructor(
    private dashboardService: DashboardService,
    private http: HttpRequestService,
    private datePipe: DatePipe,
    private excelService: ExcelService,

  ) {
    //date picker start//
    const today = new Date();
    const year = today.getFullYear();
    const month = today.getMonth();
    //start date//
    this.startDate = new FormGroup({
      start: new FormControl(new Date(year, month, 13)),
      end: new FormControl(new Date(year, month, 16)),
    });
    //end date//
    this.endDate = new FormGroup({
      start: new FormControl(new Date(year, month, 15)),
      end: new FormControl(new Date(year, month, 19)),
    });
  }
  //date picker end//





  ngOnInit() {
    let data = '';
    this.getAnalyticsCount();

    // this.getUseEnggment();

    // area chart
    this.bigChart = [
      {
        name: 'Log Out Users',
        data: [502, 635, 450, 250, 210],
        type: 'column',
      },
      {
        name: 'Active Users',
        data: [106, 107, 430, 230, 2711],
        type: 'column',
      },
      {
        name: 'supply list visited Users',
        data: [106, 107, 430, 230, 2711],
        type: 'column',
      },
      {
        name: 'supply list visited Users',
        data: [106, 107, 430, 230, 2711],
        type: 'column',
      },
      {
        name: 'supply list visited Users',
        data: [106, 107, 430, 230, 2711],
        type: 'column',
      },
      {
        name: 'supply list visited Users',
        data: [106, 107, 430, 230, 2711],
        type: 'column',
      },
    ];
    this.areaChartOptionjs = [
      {
        name: 'Supply search Page visit',
        data: [502],
        type: 'column',
      },
      {
        name: 'Supply search user wise ',
        data: [206],
        type: 'column',
      },
      {
        name: 'Requisition Search page',
        data: [200],
        type: 'column',
      },
      {
        name: 'LC profile visit',
        data: [406],
        type: 'column',
      },
      {
        name: 'Project Profile Calling Visit',
        data: [106],
        type: 'column',
      },
    ];
    // area chart
    this.gcUserChart = [
      {
        name: 'Log Out Users',
        data: [502, 635, 450, 250, 210],
        type: 'column',
      },
      {
        name: 'Active Users',
        data: [106, 107, 430, 230, 2711],
        type: 'column',
      },
      {
        name: 'supply list visited Users',
        data: [106, 107, 430, 230, 2711],
        type: 'column',
      },
      {
        name: 'supply list visited Users',
        data: [106, 107, 430, 230, 2711],
        type: 'column',
      },
      {
        name: 'supply list visited Users',
        data: [106, 107, 430, 230, 2711],
        type: 'column',
      },
      {
        name: 'supply list visited Users',
        data: [106, 107, 430, 230, 2711],
        type: 'column',
      },
    ];
    this.lcUserChart = [
      {
        name: 'Log Out Users',
        data: [502, 635, 450, 250, 210],
        type: 'column',
      },
      {
        name: 'Active Users',
        data: [106, 107, 430, 230, 2711],
        type: 'column',
      },
      {
        name: 'supply list visited Users',
        data: [106, 107, 430, 230, 2711],
        type: 'column',
      },
      {
        name: 'supply list visited Users',
        data: [106, 107, 430, 230, 2711],
        type: 'column',
      },
      {
        name: 'supply list visited Users',
        data: [106, 107, 430, 230, 2711],
        type: 'column',
      },
      {
        name: 'supply list visited Users',
        data: [106, 107, 430, 230, 2711],
        type: 'column',
      },
    ];
    this.getGcLcJs = [
      {
        name: 'GC not logged Users',
        data: [502],
        type: 'column',
      },
      {
        name: 'GC logged Users',
        data: [106],
        type: 'column',
      },
      {
        name: 'LC not logged Users',
        data: [106],
        type: 'column',
      },
      {
        name: 'LC logged Users',
        data: [106],
        type: 'column',
      },
    ];

    /////////////////////////////////////////
    // pei charts
    ///////////////////////////////////////////

    // Overall engament
    this.pierChartJs = [
      {
        name: 'Supply search Page visit',
        y: 1000,
        sliced: true,
        selected: true,
      },
      {
        name: 'Supply search user wise ',
        y: 2000,
      },
      {
        name: 'Requisition Search page',
        y: 10.85,
      },
      {
        name: 'LC profile visit',
        y: 4.67,
      },
    ];
    //  user Overall engament
    this.getUserJs = [
      {
        name: ' Not Loged User',
        y: 2000,
        sliced: true,
        selected: true,
      },
      {
        name: 'Loged User',
        y: 1000,
      },
    ];

    // Overall engament
    this.userTypeData = [
      {
        name: 'Sub Contractor',
        y: 0.0,
        sliced: true,
        selected: true,
      },
      {
        name: 'General Contractor',
        y: 0.0,
      },
    ];
    /////////////////////////////////////////
    // chart js setting
    ////////////////////////////////////////////
    // user are apis high charts setting
    this.chartOptions = {
      chart: {
        type: 'column',
      },
      event: {},
      title: {
        text: 'Overall User Interaction',
      },
      subtitle: {
        text: 'Summary',
      },
      tooltip: {
        split: true,
        // valueSuffix: ' Thousands',
      },
      credits: {
        enabled: false,
      },
      exporting: {
        enabled: true,
      },
      series: this.bigChart,
    };
    this.areaChartOption = {
      chart: {
        type: 'line',
      },
      event: {},
      title: {
        text: 'Overall Engagement',
      },
      subtitle: {
        text: 'Summary',
      },
      tooltip: {
        split: true,
        // valueSuffix: ' Thousands',
      },
      credits: {
        enabled: false,
      },
      exporting: {
        enabled: true,
      },
      series: this.areaChartOptionjs,
    };
    this.gcUserOptions = {
      chart: {
        type: 'line',
      },
      event: {},
      title: {
        text: 'General Contractor Interaction',
      },
      subtitle: {
        text: 'Summary',
      },
      tooltip: {
        split: true,
        // valueSuffix: ' Thousands',
      },
      credits: {
        enabled: false,
      },
      exporting: {
        enabled: true,
      },
      series: this.gcUserChart,
    };
    this.lcUserOptions = {
      chart: {
        type: 'line',
      },
      event: {},
      title: {
        text: 'Sub Contractor Interaction',
      },
      subtitle: {
        text: 'Summary',
      },
      tooltip: {
        split: true,
        // valueSuffix: ' Thousands',
      },
      credits: {
        enabled: false,
      },
      exporting: {
        enabled: true,
      },
      series: this.lcUserChart,
    };
    this.getGcLcUserPierCharts = {
      chart: {
        type: 'line',
      },
      event: {},
      title: {
        text: 'GC and LC Engagment',
      },
      subtitle: {
        text: 'Summary',
      },
      tooltip: {
        split: true,
        // valueSuffix: ' Thousands',
      },
      credits: {
        enabled: false,
      },
      exporting: {
        enabled: true,
      },
      series: this.getGcLcJs,
    };

    // pie chart integration overall  engaement
    this.PieChartOption = {
      chart: {
        plotBackgroundColor: null,
        plotBorderWidth: null,
        plotShadow: false,
        type: 'pie',
      },
      title: {
        text: 'Overall Engagement',
      },
      tooltip: {
        pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>',
      },
      plotOptions: {
        pie: {
          allowPointSelect: true,
          cursor: 'pointer',
          dataLabels: {
            enabled: true,
            format: '<b>{point.name}</b>: {point.percentage:.1f} %',
          },
        },
      },
      exporting: {
        enabled: true,
      },
      credits: {
        enabled: false,
      },
      series: [
        {
          name: 'Brands',
          colorByPoint: true,
          data: this.pierChartJs,
        },
      ],
    };
    // pie chart integration overall  engaement
    this.getUserPierCharts = {
      chart: {
        plotBackgroundColor: null,
        plotBorderWidth: null,
        plotShadow: false,
        type: 'pie',
      },
      title: {
        text: 'Engagged & Non-Engaged Users',
      },
      tooltip: {
        pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>',
      },
      plotOptions: {
        pie: {
          allowPointSelect: true,
          cursor: 'pointer',
          dataLabels: {
            enabled: true,
            format: '<b>{point.name}</b>: {point.percentage:.1f} %',
          },
        },
      },
      exporting: {
        enabled: true,
      },
      credits: {
        enabled: false,
      },
      series: [
        {
          name: 'Brands',
          colorByPoint: true,
          data: this.getUserJs,
        },
      ],
    };
    // pie chart integration overall  engaement
    this.UserTypesOptions = {
      chart: {
        plotBackgroundColor: null,
        plotBorderWidth: null,
        plotShadow: false,
        type: 'pie',
      },
      title: {
        text: 'Engagement by General Contractor & Sub Contractor',
      },
      tooltip: {
        pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>',
      },
      plotOptions: {
        pie: {
          allowPointSelect: true,
          cursor: 'pointer',
          dataLabels: {
            enabled: true,
            format: '<b>{point.name}</b>: {point.percentage:.1f} %',
          },
        },
      },
      exporting: {
        enabled: true,
      },
      credits: {
        enabled: false,
      },
      series: [
        {
          name: 'Brands',
          colorByPoint: true,
          data: this.userTypeData,
        },
      ],
    };
    HC_exporting(Highcharts);
    setTimeout(() => {
      window.dispatchEvent(new Event('resize'));
    }, 3000);

    this.cards = this.dashboardService.cards();
    this.pieChart = this.dashboardService.pieChart();

    //call user analytics
    // this.getUserAnalyticDateWise();
    // this.getRequisitionSearchUserWiseAnlytics(data);
    // this.getSupplySearchUserWiseAnlytics(data);

    this.getUserAnalytic(data);
    this.getRequisitionSearchAnalytics(data);
    this.getLcProfileAnlytics(data);
    this.getRequisitionSearchLcCalling(data);
    this.getSupplySearchAnlytics(data);
    this.getSupplySearchLcCallingAnlytics(data);
    this.getUseEnggment();
  }

  ngAfterContentChecked() {
    // console.log("after chehcked");
  }
  ngDoCheck() { }

  ngAfterViewInit() { }

  // datalocalstorage() {
  //   this.getGcLcJs = [];
  //   this.getUserJs = [];
  //   let res = JSON.parse(localStorage.getItem('engageduser'));
  //   console.log('engament of user', res);

  //   let data = res['data'];

  //   console.log('data local', data);

  //   let notloginuserList = data.filter((item) => item.last_login == null);

  //   let loginUser = data.filter((item) => item.last_login != null);

  //   // console.log("over all not log in user list",notloginuserList);
  //   console.log(
  //     ' over all  not log in user list count',
  //     notloginuserList.length
  //   );

  //   // console.log(" over all  log in user list",loginUser);
  //   console.log(' over all  log in user list count', loginUser.length);

  //   let gcNotloginuser = notloginuserList.filter(
  //     (item) => item.role['id'] == 2
  //   );

  //   // console.log("over all not login gc user",gcNotloginuser);
  //   console.log('over all not login gc user count', gcNotloginuser.length);

  //   let lcNotloginuser = notloginuserList.filter(
  //     (item) => item.role['id'] == 3
  //   );

  //   // console.log("over all not login lc user",lcNotloginuser);
  //   console.log('over all not login lc user count', lcNotloginuser.length);

  //   let gcLoginUser = loginUser.filter((item) => item.role['id'] == 2);

  //   // console.log("log in user gc", gcLoginUser);
  //   console.log('log in user gc count', gcLoginUser.length);

  //   let lcLoginUser = loginUser.filter((item) => item.role['id'] == 3);

  //   // console.log("log in user lc", lcLoginUser);
  //   console.log('log in user lc count', lcLoginUser.length);

  //   this.getUserJs.push(
  //     {
  //       name: 'Overall Engaged Users',
  //       y: loginUser.length,
  //     },
  //     {
  //       name: 'Overall Non-Engaged Users',
  //       y: notloginuserList.length,
  //     }
  //   );

  //   // get gc lc js

  //   this.getGcLcJs.push(
  //     {
  //       name: 'GC not logged Users',
  //       data: [gcNotloginuser.length],
  //       type: 'column',
  //     },
  //     {
  //       name: 'GC logged Users',
  //       data: [gcLoginUser.length],
  //       type: 'column',
  //     },
  //     {
  //       name: 'LC not logged Users',
  //       data: [lcNotloginuser.length],
  //       type: 'column',
  //     },
  //     {
  //       name: 'LC logged Users',
  //       data: [lcLoginUser.length],
  //       type: 'column',
  //     }
  //   );

  //   this.getGcLcUserPierCharts = {
  //     title: {
  //       text: 'GC and LC Engagment',
  //     },
  //     series: this.getGcLcJs,
  //   };

  //   this.getUserPierCharts = {
  //     chart: {
  //       plotBackgroundColor: null,
  //       plotBorderWidth: null,
  //       plotShadow: false,
  //       type: 'pie',
  //     },

  //     title: {
  //       text: 'Engagged & Non-Engaged Users',
  //     },

  //     series: [
  //       {
  //         name: 'Brands',
  //         colorByPoint: true,
  //         data: this.getUserJs,
  //       },
  //     ],
  //   };

  //   console.log('gc and lc view', this.getGcLcJs);
  // }

  ///////////////////////////////////
  // search function
  //////////////////////////////////////
  searchForm(val) {
    this.onSearch = false;

    this.OverallView = [];

    console.log('gc value', this.gcShow);
    console.log('lc value', this.lcShow);

    this.companyName = true;
    this.title = val.value;
    this.OverallView = [];
    let data = val.value;


    this.getRequisitionSearchAnalytics(data);
    this.getLcProfileAnlytics(data);
    this.getRequisitionSearchLcCalling(data);
    this.getSupplySearchAnlytics(data);
    this.getSupplySearchLcCallingAnlytics(data);


    // if (this.gcShow) {
    //   this.gcSearch = true;
    //   this.getRequisitionSearchAnalytics(data);
    //   this.getLcProfileAnlytics(data);
    //   this.getRequisitionSearchLcCalling(data);

    //   // this.getSupplySearchAnlytics(data);
    //   // this.getSupplySearchLcCallingAnlytics(data);
    // } else {
    //   if (this.lcShow) {
    //     this.lcSearch = true;
    //     this.getSupplySearchAnlytics(data);
    //     this.getSupplySearchLcCallingAnlytics(data);
    //   } else {
    //     this.onSearch = true;
    //     this.getRequisitionSearchAnalytics(data);
    //     this.getLcProfileAnlytics(data);
    //     this.getRequisitionSearchLcCalling(data);
    //     this.getSupplySearchAnlytics(data);
    //     this.getSupplySearchLcCallingAnlytics(data);
    //   }
    // }

    // use for track

    this.getUserAnalytic(data);
  }
  exportexcel(val): void {
    console.log('tag name', val);

    ////////////////////////////////////////////////
    // total dashboard count record
    ////////////////////////////////////////
    /* table id is passed over here */
    let element = document.getElementById(val);
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);

    /* generate workbook and add the worksheet */
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'analytics');

    /* save to file */
    XLSX.writeFile(wb, 'Tota_dashboard_count_ExcelSheet.xlsx');

    ///////////////////////////////////////////
    // overall user analytics
    //////////////////////////////////////////
    // /* table id is passed over here */
    // let element1 = document.getElementById('overall-user-analytics');
    // const ws1: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element1);
    // /* generate workbook and add the worksheet */
    // const wb1: XLSX.WorkBook = XLSX.utils.book_new();
    // XLSX.utils.book_append_sheet(wb1, ws1, 'analytics');
    // /* save to file */
    // XLSX.writeFile(wb1, this.fileName);

    ///////////////////////////////////////////
    // requisition search analytics   api 1
    //////////////////////////////////////////
    /* table id is passed over here */
    let element2 = document.getElementById('requisition_search_analytics');
    const ws2: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element2);
    /* generate workbook and add the worksheet */
    const wb2: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb2, ws2, 'analytics');
    /* save to file */
    XLSX.writeFile(wb2, 'Requisition_search_analytics_ExcelSheet.xlsx');

    ///////////////////////////////////////////
    // requisition search lc calling analytics  api 2
    //////////////////////////////////////////
    /* table id is passed over here */
    let element3 = document.getElementById(
      'requisition_search_calling_analytics'
    );
    const ws3: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element3);
    /* generate workbook and add the worksheet */
    const wb3: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb3, ws3, 'analytics');
    /* save to file */
    XLSX.writeFile(wb3, 'LC_profile_visit_calling_analytics_ExcelSheet.xlsx');

    ///////////////////////////////////////////
    // requisition search lc calling analytics  api 3
    //////////////////////////////////////////
    /* table id is passed over here */
    let element4 = document.getElementById('lc_profile_visit_analytics');
    const ws4: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element4);
    /* generate workbook and add the worksheet */
    const wb4: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb4, ws4, 'analytics');
    /* save to file */
    XLSX.writeFile(wb4, 'Lc_profile_visit_analytics_ExcelSheet.xlsx');

    ///////////////////////////////////////////
    // supply search page analytics  api 5   more data
    //////////////////////////////////////////
    /* table id is passed over here */
    let element5 = document.getElementById('supply_search_analytics');
    const ws5: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element5);
    /* generate workbook and add the worksheet */
    const wb5: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb5, ws5, 'analytics');
    /* save to file */
    XLSX.writeFile(wb5, 'Supply_search_page_analytics_ExcelSheet.xlsx');

    ///////////////////////////////////////////
    // requisition search lc calling analytics  api 3
    //////////////////////////////////////////
    /* table id is passed over here */
    let element6 = document.getElementById('project_profile_calling_analytics');
    const ws6: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element6);
    /* generate workbook and add the worksheet */
    const wb6: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb6, ws6, 'analytics');
    /* save to file */
    XLSX.writeFile(wb6, 'Project_profile_calling_analytics_ExcelSheet.xlsx');
  }

  // refresh the data
  resetval() {
    let data = '';
    this.getAnalyticsCount();
    this.getUserAnalytic(data);
    this.getRequisitionSearchAnalytics(data);
    this.getLcProfileAnlytics(data);
    this.getRequisitionSearchLcCalling(data);
    this.getSupplySearchAnlytics(data);
    this.getSupplySearchLcCallingAnlytics(data);
    this.getUseEnggment();
  }



  ////////////////////////////////////////////////////
  // user analytics date wise ---not in user now
  ///////////////////////////////////////////////
  getUserAnalyticDateWise() {
    // creating  array of object for data
    let AllLogOutCount = [];
    let AllActiveCount = [];
    let ALLsupplySearchUsers = [];
    let AllprojectViewUsers = [];
    let ALLrequisitionSearchUsers = [];
    let AllsubContractorViewUsers = [];
    let AlltotalProectUsers = [];
    let AlltotalgcUsers = [];

    /////////////////////////////////////
    // date formating and list
    ////////////////////////////////////
    let currentDate = formatDate(new Date(), 'yyyy/MM/dd', 'en');

    // previous 1
    let Date_1 = new Date();
    Date_1.setDate(Date_1.getDate() - 1);
    let FormateDate_1 = formatDate(Date_1, 'yyyy/MM/dd', 'en');

    // previous 2
    let Date_2 = new Date();
    Date_2.setDate(Date_2.getDate() - 2);
    let FormateDate_2 = formatDate(Date_2, 'yyyy/MM/dd', 'en');

    // previou 3
    let Date_3 = new Date();
    Date_3.setDate(Date_3.getDate() - 3);
    let FormateDate_3 = formatDate(Date_3, 'yyyy/MM/dd', 'en');

    // previous 4
    let Date_4 = new Date();
    Date_4.setDate(Date_4.getDate() - 4);
    let FormateDate_4 = formatDate(Date_4, 'yyyy/MM/dd', 'en');

    // for  current date
    this.http
      .request(
        'get',
        '/analytics/get-user-analytics/?from_date=' +
        currentDate +
        '&to_date=' +
        currentDate,
        null
      )
      .subscribe((res) => {
        try {
          console.log('user analytics', res);
          // console.log("single user analytics", res[0]);
          let ActiveDashboardUsers = res.data.filter(
            (item) => item.screen_name == 'On Dashboard'
          );
          let supplySearchUsers = res.data.filter(
            (item) => item.screen_name == 'On Supply Search Page'
          );
          let projectViewUsers = res.data.filter(
            (item) => item.screen_name == 'Supply Search View Project Profile'
          );
          let requisitionSearchUsers = res.data.filter(
            (item) => item.screen_name == 'On Requisition Search Page'
          );
          let subContractorViewUsers = res.data.filter(
            (item) =>
              item.screen_name ==
              'Requisition Search View Sub Contractor Profile'
          );
          let totalProectUsers = res.data.filter(
            (item) => item.screen_name == 'Total Projects'
          );
          let totalgcUsers = res.data.filter(
            (item) => item.screen_name == 'Total General Contractors'
          );
          let totalSupplyUsers = res.data.filter(
            (item) => item.screen_name == 'Supply List'
          );
          let totalRequisitionUsers = res.data.filter(
            (item) => item.screen_name == 'Requisition List'
          );
          let logoutUsers = res.data.filter(
            (item) => item.screen_name == 'Logout'
          );

          // console.log('logOut Users', logoutUsers.length);
          // console.log('ActiveDashboardUsers', ActiveDashboardUsers.length);
          // console.log('supplySearchUsers', supplySearchUsers.length);
          // console.log('projectViewUsers', projectViewUsers.length);
          // console.log('requisitionSearchUsers', requisitionSearchUsers.length);
          // console.log('subContractorViewUsers', subContractorViewUsers.length);
          // console.log('totalProectUsers', totalProectUsers.length);
          // console.log('totalgcUsers', totalgcUsers.length);

          // inserting value into array
          AllLogOutCount.push(logoutUsers.length);
          AllActiveCount.push(ActiveDashboardUsers.length);
          AllprojectViewUsers.push(projectViewUsers.length);
          AllsubContractorViewUsers.push(subContractorViewUsers.length);
          AlltotalProectUsers.push(totalProectUsers.length);
          AlltotalgcUsers.push(totalgcUsers.length);
          ALLrequisitionSearchUsers.push(requisitionSearchUsers.length);
          ALLsupplySearchUsers.push(supplySearchUsers.length);

          // console.log('logout user count', AllLogOutCount);
          // console.log('AllActiveCount user count', AllActiveCount);
          // console.log('AllprojectViewUsers user count', AllprojectViewUsers);
          // console.log('AllsubContractorViewUsers user count', AllsubContractorViewUsers);
          // console.log('AlltotalProectUsers user count', AlltotalProectUsers);
          // console.log('AlltotalgcUsers user count', AlltotalgcUsers);
          // console.log('ALLrequisitionSearchUsers user count', ALLrequisitionSearchUsers);
          // console.log('ALLsupplySearchUsers user count', ALLsupplySearchUsers);

          // return res
        } catch (error) {
          console.log('error', error);
        }
      });

    // for previous day -1
    this.http
      .request(
        'get',
        '/analytics/get-user-analytics/?from_date=' +
        FormateDate_1 +
        '&to_date=' +
        FormateDate_1,
        null
      )
      .subscribe((res) => {
        try {
          let ActiveDashboardUsers = res.data.filter(
            (item) => item.screen_name == 'On Dashboard'
          );
          let supplySearchUsers = res.data.filter(
            (item) => item.screen_name == 'On Supply Search Page'
          );
          let projectViewUsers = res.data.filter(
            (item) => item.screen_name == 'Supply Search View Project Profile'
          );
          let requisitionSearchUsers = res.data.filter(
            (item) => item.screen_name == 'On Requisition Search Page'
          );
          let subContractorViewUsers = res.data.filter(
            (item) =>
              item.screen_name ==
              'Requisition Search View Sub Contractor Profile'
          );
          let totalProectUsers = res.data.filter(
            (item) => item.screen_name == 'Total Projects'
          );
          let totalgcUsers = res.data.filter(
            (item) => item.screen_name == 'Total General Contractors'
          );
          let totalSupplyUsers = res.data.filter(
            (item) => item.screen_name == 'Supply List'
          );
          let totalRequisitionUsers = res.data.filter(
            (item) => item.screen_name == 'Requisition List'
          );
          let logoutUsers = res.data.filter(
            (item) => item.screen_name == 'Logout'
          );

          // inserting value into array
          AllLogOutCount.push(logoutUsers.length);
          AllActiveCount.push(ActiveDashboardUsers.length);
          AllprojectViewUsers.push(projectViewUsers.length);
          AllsubContractorViewUsers.push(subContractorViewUsers.length);
          AlltotalProectUsers.push(totalProectUsers.length);
          AlltotalgcUsers.push(totalgcUsers.length);
          ALLrequisitionSearchUsers.push(requisitionSearchUsers.length);
          ALLsupplySearchUsers.push(supplySearchUsers.length);
          // return res
        } catch (error) {
          console.log('error', error);
        }
      });
    // for previous day -2
    this.http
      .request(
        'get',
        '/analytics/get-user-analytics/?from_date=' +
        FormateDate_2 +
        '&to_date=' +
        FormateDate_2,
        null
      )
      .subscribe((res) => {
        try {
          let ActiveDashboardUsers = res.data.filter(
            (item) => item.screen_name == 'On Dashboard'
          );
          let supplySearchUsers = res.data.filter(
            (item) => item.screen_name == 'On Supply Search Page'
          );
          let projectViewUsers = res.data.filter(
            (item) => item.screen_name == 'Supply Search View Project Profile'
          );
          let requisitionSearchUsers = res.data.filter(
            (item) => item.screen_name == 'On Requisition Search Page'
          );
          let subContractorViewUsers = res.data.filter(
            (item) =>
              item.screen_name ==
              'Requisition Search View Sub Contractor Profile'
          );
          let totalProectUsers = res.data.filter(
            (item) => item.screen_name == 'Total Projects'
          );
          let totalgcUsers = res.data.filter(
            (item) => item.screen_name == 'Total General Contractors'
          );
          let totalSupplyUsers = res.data.filter(
            (item) => item.screen_name == 'Supply List'
          );
          let totalRequisitionUsers = res.data.filter(
            (item) => item.screen_name == 'Requisition List'
          );
          let logoutUsers = res.data.filter(
            (item) => item.screen_name == 'Logout'
          );

          // inserting value into array
          AllLogOutCount.push(logoutUsers.length);
          AllActiveCount.push(ActiveDashboardUsers.length);
          AllprojectViewUsers.push(projectViewUsers.length);
          AllsubContractorViewUsers.push(subContractorViewUsers.length);
          AlltotalProectUsers.push(totalProectUsers.length);
          AlltotalgcUsers.push(totalgcUsers.length);
          ALLrequisitionSearchUsers.push(requisitionSearchUsers.length);
          ALLsupplySearchUsers.push(supplySearchUsers.length);
          // return res
        } catch (error) {
          console.log('error', error);
        }
      });
    // for previous day -3
    this.http
      .request(
        'get',
        '/analytics/get-user-analytics/?from_date=' +
        FormateDate_3 +
        '&to_date=' +
        FormateDate_3,
        null
      )
      .subscribe((res) => {
        try {
          let ActiveDashboardUsers = res.data.filter(
            (item) => item.screen_name == 'On Dashboard'
          );
          let supplySearchUsers = res.data.filter(
            (item) => item.screen_name == 'On Supply Search Page'
          );
          let projectViewUsers = res.data.filter(
            (item) => item.screen_name == 'Supply Search View Project Profile'
          );
          let requisitionSearchUsers = res.data.filter(
            (item) => item.screen_name == 'On Requisition Search Page'
          );
          let subContractorViewUsers = res.data.filter(
            (item) =>
              item.screen_name ==
              'Requisition Search View Sub Contractor Profile'
          );
          let totalProectUsers = res.data.filter(
            (item) => item.screen_name == 'Total Projects'
          );
          let totalgcUsers = res.data.filter(
            (item) => item.screen_name == 'Total General Contractors'
          );
          let totalSupplyUsers = res.data.filter(
            (item) => item.screen_name == 'Supply List'
          );
          let totalRequisitionUsers = res.data.filter(
            (item) => item.screen_name == 'Requisition List'
          );
          let logoutUsers = res.data.filter(
            (item) => item.screen_name == 'Logout'
          );

          // inserting value into array
          AllLogOutCount.push(logoutUsers.length);
          AllActiveCount.push(ActiveDashboardUsers.length);
          AllprojectViewUsers.push(projectViewUsers.length);
          AllsubContractorViewUsers.push(subContractorViewUsers.length);
          AlltotalProectUsers.push(totalProectUsers.length);
          AlltotalgcUsers.push(totalgcUsers.length);
          ALLrequisitionSearchUsers.push(requisitionSearchUsers.length);
          ALLsupplySearchUsers.push(supplySearchUsers.length);
          // return res
        } catch (error) {
          console.log('error', error);
        }
      });
    // for previous day -4
    this.http
      .request(
        'get',
        '/analytics/get-user-analytics/?from_date=' +
        FormateDate_4 +
        '&to_date=' +
        FormateDate_4,
        null
      )
      .subscribe((res) => {
        try {
          let ActiveDashboardUsers = res.data.filter(
            (item) => item.screen_name == 'On Dashboard'
          );
          let supplySearchUsers = res.data.filter(
            (item) => item.screen_name == 'On Supply Search Page'
          );
          let projectViewUsers = res.data.filter(
            (item) => item.screen_name == 'Supply Search View Project Profile'
          );
          let requisitionSearchUsers = res.data.filter(
            (item) => item.screen_name == 'On Requisition Search Page'
          );
          let subContractorViewUsers = res.data.filter(
            (item) =>
              item.screen_name ==
              'Requisition Search View Sub Contractor Profile'
          );
          let totalProectUsers = res.data.filter(
            (item) => item.screen_name == 'Total Projects'
          );
          let totalgcUsers = res.data.filter(
            (item) => item.screen_name == 'Total General Contractors'
          );
          let totalSupplyUsers = res.data.filter(
            (item) => item.screen_name == 'Supply List'
          );
          let totalRequisitionUsers = res.data.filter(
            (item) => item.screen_name == 'Requisition List'
          );
          let logoutUsers = res.data.filter(
            (item) => item.screen_name == 'Logout'
          );

          // inserting value into array
          AllLogOutCount.push(logoutUsers.length);
          AllActiveCount.push(ActiveDashboardUsers.length);
          AllprojectViewUsers.push(projectViewUsers.length);
          AllsubContractorViewUsers.push(subContractorViewUsers.length);
          AlltotalProectUsers.push(totalProectUsers.length);
          AlltotalgcUsers.push(totalgcUsers.length);
          ALLrequisitionSearchUsers.push(requisitionSearchUsers.length);
          ALLsupplySearchUsers.push(supplySearchUsers.length);

          // console.log('logout user count', AllLogOutCount);
          // console.log('AllActiveCount user count', AllActiveCount);
          // console.log('AllprojectViewUsers user count', AllprojectViewUsers);
          // console.log('AllsubContractorViewUsers user count', AllsubContractorViewUsers);
          // console.log('AlltotalProectUsers user count', AlltotalProectUsers);
          // console.log('AlltotalgcUsers user count', AlltotalgcUsers);
          // console.log('ALLrequisitionSearchUsers user count', ALLrequisitionSearchUsers);
          // console.log('ALLsupplySearchUsers user count', ALLsupplySearchUsers);

          let ArrayOfUserAnlytics = [
            {
              name: 'Log Out Users',
              data: AllLogOutCount,
              type: 'column',
            },
            {
              name: 'Active Users',
              data: AllActiveCount,
              type: 'column',
            },
            {
              name: 'Supply Search Users',
              data: ALLsupplySearchUsers,
              type: 'column',
            },
          ];

          this.bigChart = ArrayOfUserAnlytics;
          // intilising leates value into chart
          this.chartOptions = {
            series: this.bigChart,
          };

          // return res
        } catch (error) {
          console.log('error', error);
        }
      });
  }

  // logged or not logged user api
  getUseEnggment() {
    this.http
      .request('get', '/user/get-user-list/?show=All', null)
      .subscribe((res) => {
        console.log('engament of user', res);

        // localStorage.setItem('engageduser', JSON.stringify(res));

        let data = res.data;

        let notloginuserList = data.filter((item) => item.last_login == null);

        let loginUser = data.filter((item) => item.last_login != null);

        let gcNotloginuser = notloginuserList.filter(
          (item) => item['user_type'] == 'General Contractor'
        );

        // console.log("over all not login gc user",gcNotloginuser);
        console.log('over all not login gc user count', gcNotloginuser.length);

        let lcNotloginuser = notloginuserList.filter(
          (item) => item['user_type'] == 'Sub Contractor'
        );

        // console.log("over all not login lc user",lcNotloginuser);
        console.log('over all not login lc user count', lcNotloginuser.length);

        let gcLoginUser = loginUser.filter(
          (item) => item['user_type'] == 'General Contractor'
        );

        // console.log("log in user gc", gcLoginUser);
        console.log('log in user gc count', gcLoginUser.length);

        let lcLoginUser = loginUser.filter(
          (item) => item['user_type'] == 'Sub Contractor'
        );

        // console.log("log in user lc", lcLoginUser);
        console.log('log in user lc count', lcLoginUser.length);

        let UserTypeData = [
          {
            name: 'General Contractor',
            y: gcLoginUser.length + gcNotloginuser.length,
          },
          {
            name: 'Sub Contractor',
            y: lcNotloginuser.length + lcLoginUser.length,
          },
        ];

        this.UserTypesOptions = {
          series: [
            {
              name: 'Brands',
              colorByPoint: true,
              data: UserTypeData,
            },
          ],
        };

        this.getUserJs = [];

        this.getUserJs.push(
          {
            name: 'Overall Engaged Users',
            y: loginUser.length,
          },
          {
            name: 'Overall Non-Engaged Users',
            y: notloginuserList.length,
          }
        );

        // get gc lc js

        this.getGcLcJs = [
          {
            name: 'GC not logged Users - ' + gcNotloginuser.length,
            data: [gcNotloginuser.length],
            type: 'column',
          },
          {
            name: 'GC logged Users - ' + gcLoginUser.length,
            data: [gcLoginUser.length],
            type: 'column',
          },
          {
            name: 'LC not logged Users - ' + lcNotloginuser.length,
            data: [lcNotloginuser.length],
            type: 'column',
          },
          {
            name: 'LC logged Users - ' + lcLoginUser.length,
            data: [lcLoginUser.length],
            type: 'column',
          },
        ];

        this.getGcLcUserPierCharts = {
          chart: {
            type: 'line',
          },
          title: {
            text: 'GC and LC Engagment',
          },
          series: this.getGcLcJs,
        };

        console.log('gc lc  engamentr-1', this.getGcLcJs);

        this.getUserPierCharts = {
          chart: {
            plotBackgroundColor: null,
            plotBorderWidth: null,
            plotShadow: false,
            type: 'pie',
          },

          title: {
            text: 'Engagged & Non-Engaged Users',
          },

          series: [
            {
              name: 'Brands',
              colorByPoint: true,
              data: this.getUserJs,
            },
          ],
        };
      });
  }

  // user analytics all
  getUserAnalytic(data) {
    let url = '';
    if (data.company_name) {
      url += '?company_name=' + data.company_name;
    } else {
      url += '?company_name= ';
    }
    if (data.from_date) {
      url += '&from_date=' + formatDate(data.from_date, 'yyyy/MM/dd', 'en');
    }
    if (data.to_date) {
      url += '&to_date=' + formatDate(data.to_date, 'yyyy/MM/dd', 'en');
    }

    // creating  array of object for data
    let AllLogOutCount = [];
    let AllActiveCount = [];
    let ALLsupplySearchUsers = [];
    let AllprojectViewUsers = [];
    let ALLrequisitionSearchUsers = [];
    let AllsubContractorViewUsers = [];
    let AlltotalProectUsers = [];
    let AlltotalgcUsers = [];

    // for  current date
    this.http
      .request('get', '/analytics/get-user-analytics/' + url, null)
      .subscribe((res) => {
        try {
          console.log('user anlytics data', res);

          this.userAnlyticsData = res.data;

          let CaptechUser = res.data.filter(
            (item) => item.user_type == 'Captech User'
          );
          let GcUser = res.data.filter(
            (item) => item.user_type == 'General Contractor'
          );
          let LcUser = res.data.filter(
            (item) => item.user_type == 'Sub Contractor'
          );

          console.log('gc user-analytics', GcUser);
          console.log('lc user-analytics', LcUser);
          console.log('BO user-analytics', CaptechUser);

          /////////////////////////////////////////////
          // totoal records sorting according to screen name
          /////////////////////////////////////////
          let ActiveDashboardUsers = res.data.filter(
            (item) => item.screen_name == 'On Dashboard'
          );
          let supplySearchUsers = res.data.filter(
            (item) => item.screen_name == 'On Supply Search Page'
          );
          let projectViewUsers = res.data.filter(
            (item) => item.screen_name == 'Supply Search View Project Profile'
          );
          let requisitionSearchUsers = res.data.filter(
            (item) => item.screen_name == 'On Requisition Search Page'
          );
          let subContractorViewUsers = res.data.filter(
            (item) =>
              item.screen_name ==
              'Requisition Search View Sub Contractor Profile'
          );
          let totalProectUsers = res.data.filter(
            (item) => item.screen_name == 'Total Projects'
          );
          let totalgcUsers = res.data.filter(
            (item) => item.screen_name == 'Total General Contractors'
          );

          console.log('total gc list', totalgcUsers);

          let totalSupplyUsers = res.data.filter(
            (item) => item.screen_name == 'Supply List'
          );
          let totalRequisitionUsers = res.data.filter(
            (item) => item.screen_name == 'Requisition List'
          );
          let logoutUsers = res.data.filter(
            (item) => item.screen_name == 'Logout'
          );

          // inserting value into array
          AllLogOutCount.push(logoutUsers.length);
          AllActiveCount.push(ActiveDashboardUsers.length);
          AllprojectViewUsers.push(projectViewUsers.length);
          AllsubContractorViewUsers.push(subContractorViewUsers.length);
          AlltotalProectUsers.push(totalProectUsers.length);
          AlltotalgcUsers.push(totalgcUsers.length);
          ALLrequisitionSearchUsers.push(requisitionSearchUsers.length);
          ALLsupplySearchUsers.push(supplySearchUsers.length);

          let ArrayOfUserAnlytics = [
            {
              name: 'Log Out Users = ' + logoutUsers.length,
              data: AllLogOutCount,
              type: 'column',
            },
            {
              name: 'Dashboard Visits = ' + ActiveDashboardUsers.length,
              data: AllActiveCount,
              type: 'column',
            },
            {
              name: 'Project Profile Visits = ' + projectViewUsers.length,
              data: AllprojectViewUsers,
              type: 'column',
            },
            {
              name:
                'Sub Contractor Profile Visits = ' + AllsubContractorViewUsers,
              data: AllsubContractorViewUsers,
              type: 'column',
            },
            {
              name:
                'Project List Visits on Dashboard Tiles = ' +
                AlltotalProectUsers,
              data: AlltotalProectUsers,
              type: 'column',
            },
            {
              name:
                'General Contractor List Visits on Dashboard Tiles  = ' +
                AlltotalgcUsers,
              data: AlltotalgcUsers,
              type: 'column',
            },
            {
              name:
                'Requisition Search Page Visits  = ' +
                ALLrequisitionSearchUsers,
              data: ALLrequisitionSearchUsers,
              type: 'column',
            },
            {
              name: 'Supply Search Page Visits = ' + ALLsupplySearchUsers,
              data: ALLsupplySearchUsers,
              type: 'column',
            },
          ];

          let chartData = ArrayOfUserAnlytics;

          // intilising leates value into chart
          this.chartOptions = {
            series: chartData,
          };

          //////////////////////////////////////////////////
          // gc user records
          ///////////////////////////////////////////////////

          let GcActiveDashboardUsers = ActiveDashboardUsers.filter(
            (item) => item.user_type == 'General Contractor'
          );
          let GcsupplySearchUsers = supplySearchUsers.filter(
            (item) => item.user_type == 'General Contractor'
          );
          let GcprojectViewUsers = projectViewUsers.filter(
            (item) => item.user_type == 'General Contractor'
          );
          let GcrequisitionSearchUsers = requisitionSearchUsers.filter(
            (item) => item.user_type == 'General Contractor'
          );
          let GcsubContractorViewUsers = subContractorViewUsers.filter(
            (item) => item.user_type == 'General Contractor'
          );
          let GctotalProectUsers = totalProectUsers.filter(
            (item) => item.user_type == 'General Contractor'
          );
          let GctotalgcUsers = totalgcUsers.filter(
            (item) => item.user_type == 'General Contractor'
          );
          let GctotalSupplyUsers = totalSupplyUsers.filter(
            (item) => item.user_type == 'General Contractor'
          );
          let GctotalRequisitionUsers = totalRequisitionUsers.filter(
            (item) => item.user_type == 'General Contractor'
          );
          let GclogoutUsers = logoutUsers.filter(
            (item) => item.user_type == 'General Contractor'
          );

          let GcArrayOfUserAnlytics = [
            {
              name: 'Log Out Users = ' + GclogoutUsers.length,
              data: [GclogoutUsers.length],
            },
            {
              name: 'Dashboard Visits = ' + GcActiveDashboardUsers.length,
              data: [GcActiveDashboardUsers.length],
            },
            {
              name: 'Project Profile Visits = ' + GcprojectViewUsers.length,
              data: [GcprojectViewUsers.length],
            },
            {
              name:
                'Sub Contractor Profile Visits = ' +
                GcsubContractorViewUsers.length,
              data: [GcsubContractorViewUsers.length],
            },
            {
              name: 'Project List Visits = ' + GctotalProectUsers.length,
              data: [GctotalProectUsers.length],
            },
            {
              name: 'General Contractor List Visits = ' + GctotalgcUsers.length,
              data: [GctotalgcUsers.length],
            },
            {
              name:
                'My Requisition List Visits  = ' +
                GcrequisitionSearchUsers.length,
              data: [GcrequisitionSearchUsers.length],
            },
            {
              name: 'My Supply List  Visits = ' + GctotalSupplyUsers.length,
              data: [GctotalSupplyUsers.length],
            },
          ];

          // intilising leates value into chart
          this.gcUserOptions = {
            title: {
              text: 'General Contractor Interaction',
            },
            series: GcArrayOfUserAnlytics,
          };

          // console.log('on gc filter', GcArrayOfUserAnlytics);

          //////////////////////////////////////////////////
          // lc user records
          ///////////////////////////////////////////////////

          // let GcActiveDashboardUsers=ActiveDashboardUsers.filter( (item) => item.user_type == 'Captech User');
          let lcActiveDashboardUsers = ActiveDashboardUsers.filter(
            (item) => item.user_type == 'Sub Contractor'
          );
          let lcsupplySearchUsers = supplySearchUsers.filter(
            (item) => item.user_type == 'Sub Contractor'
          );
          let lcprojectViewUsers = projectViewUsers.filter(
            (item) => item.user_type == 'Sub Contractor'
          );
          let lcrequisitionSearchUsers = requisitionSearchUsers.filter(
            (item) => item.user_type == 'Sub Contractor'
          );
          let lcsubContractorViewUsers = subContractorViewUsers.filter(
            (item) => item.user_type == 'Sub Contractor'
          );
          let lctotalProectUsers = totalProectUsers.filter(
            (item) => item.user_type == 'Sub Contractor'
          );
          let lctotalgcUsers = totalgcUsers.filter(
            (item) => item.user_type == 'Sub Contractor'
          );
          let lctotalSupplyUsers = totalSupplyUsers.filter(
            (item) => item.user_type == 'Sub Contractor'
          );
          let lctotalRequisitionUsers = totalRequisitionUsers.filter(
            (item) => item.user_type == 'Sub Contractor'
          );
          let lclogoutUsers = logoutUsers.filter(
            (item) => item.user_type == 'Sub Contractor'
          );

          let lcArrayOfUserAnlytics = [
            {
              name: 'Log Out Users = ' + lclogoutUsers.length,
              data: [lclogoutUsers.length],
            },
            {
              name: 'Dashboard Visits = ' + lcActiveDashboardUsers.length,
              data: [lcActiveDashboardUsers.length],
            },
            {
              name: 'Project Profile Visits = ' + lcprojectViewUsers.length,
              data: [lcprojectViewUsers.length],
            },
            {
              name:
                'Sub Contractor Profile Visits = ' +
                lcsubContractorViewUsers.length,
              data: [lcsubContractorViewUsers.length],
            },
            {
              name: 'Project List Visits = ' + lctotalProectUsers.length,
              data: [lctotalProectUsers.length],
            },
            {
              name: 'General Contractor List Visits = ' + lctotalgcUsers.length,
              data: [lctotalgcUsers.length],
            },
            {
              name:
                'Requisition Search Visits  = ' +
                lcrequisitionSearchUsers.length,
              data: [lcrequisitionSearchUsers.length],
            },
            {
              name: 'Supply Search Visits = ' + lctotalSupplyUsers.length,
              data: [lctotalSupplyUsers.length],
            },
          ];

          // intilising leates value into chart
          this.lcUserOptions = {
            series: lcArrayOfUserAnlytics,
          };

          // chart js sub contractor and general contractor radar chart

          this.canvas = this.mychart.nativeElement;
          this.ctx = this.canvas.getContext('2d');
          new Chart(this.ctx, {
            type: 'line',
            data: {
              labels: [
                'Dashboard Visit',
                'Project List Visit',
                'General Contractor List Visit',
                'My Supply List Visit',
                'My Requisition List Visit',
              ],
              datasets: [
                {
                  label: 'General Contractor Dashboard Analytics',
                  data: [
                    GcActiveDashboardUsers.length,
                    GctotalProectUsers.length,
                    GctotalgcUsers.length,
                    GctotalSupplyUsers.length,
                    GcrequisitionSearchUsers.length,
                  ],
                  fill: true,
                  backgroundColor: 'rgba(255, 99, 132, 0.2)',
                  borderColor: 'rgb(255, 99, 132)',
                  pointBackgroundColor: 'rgb(255, 99, 132)',
                  pointBorderColor: '#fff',
                  pointHoverBackgroundColor: '#fff',
                  pointHoverBorderColor: 'rgb(255, 99, 132)',
                },
              ],
            },
          });

          let canvas1 = this.mychart1.nativeElement;
          let ctx1 = canvas1.getContext('2d');
          new Chart(ctx1, {
            type: 'line',
            data: {
              labels: [
                'Dashboard Visit',
                'Project List Visit',
                'General Contractor List Visit',
                'My Supply List Visit',
                'My Requisition List Visit',
              ],
              datasets: [
                {
                  label: 'Sub Contractor Dashboard Analytics',
                  data: [
                    lcActiveDashboardUsers.length,
                    lctotalProectUsers.length,
                    lctotalgcUsers.length,
                    lctotalSupplyUsers.length,
                    lcrequisitionSearchUsers.length,
                  ],
                  fill: true,
                  backgroundColor: 'rgba(54, 162, 235, 0.2)',
                  borderColor: 'rgb(54, 162, 235)',
                  pointBackgroundColor: 'rgb(54, 162, 235)',
                  pointBorderColor: '#fff',
                  pointHoverBackgroundColor: '#fff',
                  pointHoverBorderColor: 'rgb(54, 162, 235)',
                },
              ],
            },
          });

          // return res
        } catch (error) {
          console.log('error', error);
        }
      });
  }

  /////////////////////////////////////////////////////////
  // Requisition search result analytics---------1
  ///////////////////////////////////////////////////////
  getRequisitionSearchAnalytics(data) {
    // console.log('company name-->', data.company_name);

    let url = '';
    if (data.company_name) {
      url += '?company_name=' + data.company_name;
    } else {
      url += '?company_name= ';
    }
    if (data.from_date) {
      url += '&from_date=' + formatDate(data.from_date, 'yyyy/MM/dd', 'en');
    }
    if (data.to_date) {
      url += '&to_date=' + formatDate(data.to_date, 'yyyy/MM/dd', 'en');
    }
    this.http
      .request(
        'get',
        '/analytics/get-requisition-search-analytics/' + url,
        null
      )
      .subscribe((res) => {
        try {
          // let data=res.data;
          console.log(' requisition search 1 api-----------', res);
          this.requisitionSearchAnalytics = res.data;
          this.OverallView.push({
            name: 'Requisition Search Page visits',
            y: res.data.length,
          });

          this.areaChartOptionjs.push({});

          this.areaChartOption = {
            series: this.bigChart,
          };

          // this.areaChartOption.

          // from(data).pipe(
          //   groupBy(person => person['project_name'], p => p),
          //   mergeMap(group => zip(of(group.key), group.pipe(toArray())))
          // ).subscribe(res => {
          // });
        } catch (error) {
          console.log('requisition search analytics error', error);
        }
      });
  }

  //  lc calling search result------------------2
  getRequisitionSearchLcCalling(data) {

    let url = '';
    console.log('data', data);

    if (data.company_name) {
      url += '?gc_company_name=' + data.company_name;
    } else {
      url += '?gc_company_name= ';
    }
    if (data.from_date) {
      url += '&from_date=' + formatDate(data.from_date, 'yyyy/MM/dd', 'en');
    }
    if (data.to_date) {
      url += '&to_date=' + formatDate(data.to_date, 'yyyy/MM/dd', 'en');
    }
    this.http
      .request(
        'get',
        '/analytics/get-requisition-search-lc-calling-analytics/' + url,
        null
      )
      .subscribe((res) => {
        try {
          console.log('requisition search lc calling api 2 --', res);

          this.requisitionLcCalling = res.data.length;


          this.OverallView.push({
            name: 'LC profile calling visit',
            y: res.data.length,
          });


        } catch (error) { }
      });
  }

  // requisition result lc profile visit by gc ------------------------3
  getLcProfileAnlytics(data) {
    let url = '';
    if (data.company_name) {
      url += '?company_name=' + data.company_name;
    } else {
      url += '?company_name= ';
    }
    if (data.from_date) {
      url += '&from_date=' + formatDate(data.from_date, 'yyyy/MM/dd', 'en');
    }
    if (data.to_date) {
      url += '&to_date=' + formatDate(data.to_date, 'yyyy/MM/dd', 'en');
    }
    this.http
      .request(
        'get',
        '/analytics/get-requisition-search-profile-view-analytics/' + url,
        null
      )
      .subscribe((res) => {
        try {
          console.log('lc profile analytics result  api 3------', res);

          this.lcProfileVisit = res.data;
          this.OverallView.push({
            name: 'LC Profile Visit',
            y: res.data.length,
          });

          // pie chart integration
          this.PieChartOption = {
            title: {
              text: 'Overall Engagement by ' + this.userTypeValue,
            },
            series: [
              {
                name: 'Brands',
                colorByPoint: true,
                data: this.OverallView,
              },
            ],
          };

          // console.log('pie chart final val', this.OverallView);
        } catch (error) {
          console.log('project profile visit error', error);
        }
      });
  }

  // requisition search user wise analytics -------------------------   4 not in user now
  getRequisitionSearchUserWiseAnlytics(data) {
    let url = '';
    if (data.company_name) {
      url += '?company_name=' + data.company_name;
    } else {
      url += '?company_name= ';
    }
    if (data.from_date) {
      url += '&from_date=' + formatDate(data.from_date, 'yyyy/MM/dd', 'en');
    }
    if (data.to_date) {
      url += '&to_date=' + formatDate(data.to_date, 'yyyy/MM/dd', 'en');
    }

    this.http
      .request(
        'get',
        '/analytics/get-requisition-search-user-wise-analytics/' + url,
        null
      )
      .subscribe((res) => {
        try {
          console.log(
            'user wise requisition anlytics  api 4 -------------',
            res
          );
          this.OverallView.push({
            name: 'Requisition search User wise visit',
            y: res.data.length,
          });
        } catch (error) {
          console.log('user wise requisition anlytics', error);
        }
      });
  }

  // //////////////////////////////
  // Supply
  ////////////////////////////////

  // get search anlytics  -------------------------------5
  getSupplySearchAnlytics(data) {
    console.log('company name', data.company_name);

    let url = '';
    if (data.company_name) {
      url += '?company_name=' + data.company_name;
    } else {
      url += '?company_name= ';
    }

    if (data.from_date) {
      url += '&from_date=' + formatDate(data.from_date, 'yyyy/MM/dd', 'en');
    }
    if (data.to_date) {
      url += '&to_date=' + formatDate(data.to_date, 'yyyy/MM/dd', 'en');
    }

    this.http
      .request('get', '/analytics/get-supply-search-analytics/' + url, null)
      .subscribe((res) => {
        try {
          console.log(
            'supply search analytics api 5--------------------- ',
            res
          );

          this.supplySearchAnalytics = res.data;
          this.OverallView.push({
            name: 'Supply search Page visit',
            y: res.data.length,
          });

          // pie chart integration
          this.PieChartOption = {
            title: {
              text: 'Overall Engagement by ' + this.userTypeValue,
            },
            series: [
              {
                name: 'Brands',
                colorByPoint: true,
                data: this.OverallView,
              },
            ],
          };

          // console.log('api 5 data', this.OverallView);
        } catch (error) {
          console.log('supply search analytics eroor', error);
        }
      });
  }

  // project profile   calling analytics-------------------------6
  getSupplySearchLcCallingAnlytics(data) {

    let url = '';
    if (data.company_name) {
      url += '?company_name=' + data.company_name;
    } else {
      url += '?company_name= ';
    }
    if (data.from_date) {
      url += '&from_date=' + formatDate(data.from_date, 'yyyy/MM/dd', 'en');
    }
    if (data.to_date) {
      url += '&to_date=' + formatDate(data.to_date, 'yyyy/MM/dd', 'en');
    }

    this.http
      .request(
        'get',
        '/analytics/get-supply-search-lc-calling-analytics/' + url,
        null
      )
      .subscribe((res) => {
        try {
          console.log(
            'get supply search calling anlytics   api 6-------------------- ',
            res
          );

          this.projectProfileCalling = res.data.length;
          this.OverallView.push({
            name: 'Project Profile Calling Visit',
            y: res.data.length,
          });

          // pie chart integration
          this.PieChartOption = {
            title: {
              text: 'Overall Engagement by ' + this.userTypeValue,
            },
            series: [
              {
                name: 'Brands',
                colorByPoint: true,
                data: this.OverallView,
              },
            ],
          };

          // calling activity
          let canvas1 = this.callingActivity.nativeElement;
          let ctx1 = canvas1.getContext('2d');

          new Chart(ctx1, {
            type: 'doughnut',
            data: {
              labels: [
                'LC Profile Calling ',
                'Project Profile Calling ',

              ],
              datasets: [
                {
                  label: 'Calling Activity Analytics',
                  data: [this.requisitionLcCalling,
                  this.projectProfileCalling
                  ],
                  fill: true,
                  backgroundColor: [
                    'rgb(255, 99, 132)',
                    'rgb(255, 205, 86)'
                  ],

                },

              ],
            },
          });

          // console.log('pie chart final val', this.OverallView);
        } catch (error) {
          console.log('supply search calling analytics', error);
        }
      });
  }

  // supply search user wise analytics-----------------------7   not in use
  getSupplySearchUserWiseAnlytics(data) {
    let url = '';
    if (data.company_name) {
      url += '?company_name=' + data.company_name;
    } else {
      url += '?company_name= ';
    }
    if (data.from_date) {
      url += '&from_date=' + formatDate(data.from_date, 'yyyy/MM/dd', 'en');
    }
    if (data.to_date) {
      url += '&to_date=' + formatDate(data.to_date, 'yyyy/MM/dd', 'en');
    }

    this.http
      .request('get', '/analytics/get-supply-search-user-wise-analytics/', null)
      .subscribe((res) => {
        try {
          console.log(
            'supply search user wise analytics    api 7 ----------------- ',
            res
          );
          this.OverallView.push({
            name: 'Supply search user wise  visit',
            y: res.data.length,
          });

          // pie chart integration
          this.PieChartOption = {
            title: {
              text: 'Overall Engagement by ' + this.userTypeValue,
            },
            series: [
              {
                name: 'Brands',
                colorByPoint: true,
                data: this.OverallView,
              },
            ],
          };

          // console.log('api 7 data', this.OverallView);
        } catch (error) {
          console.log('supply search Uaer wise anltyics', error);
        }
      });
  }

  ////////////////////////////////////////
  // on type user list
  //////////////////////////////////////////////////
  onUserTypeChange(val) {
    // console.log('change', val);
    if (val == 'gc') {
      this.userTypeValue = 'GC';
      this.gcShow = true;
      this.lcShow = false;
      this.projectShow = false;
      this.supplyShow = false;
      this.requisitionShow = false;
      //  call gc api
      this.http
        .request(
          'get',
          '/general-contractor/get-gc-minimal/?is_active=True&show=All',
          null
        )
        .subscribe((res) => {
          this.userList = res['data'];
          // console.log('gc user list', this.userList);
        });
    }
    if (val == 'lc') {
      // call lc api
      this.userTypeValue = 'LC';
      console.log('user tyoe is lc', this.userTypeValue);
      this.gcShow = false;
      this.lcShow = true;
      this.projectShow = false;
      this.supplyShow = false;
      this.requisitionShow = false;

      this.http
        .request(
          'get',
          '/sub_contractor/get-min-list/?is_active=True&show=All',
          null
        )
        .subscribe((res) => {
          // console.log('lc user list', res);
          this.userList = res['data'];
          // console.log('lc user list', this.userList);
          // console.log('jaosn data-->', JSON.stringify(this.userList[0]));
        });
    }
    if (val == 'project') {
      this.userTypeValue = '';
      this.gcShow = false;
      this.lcShow = false;
      this.projectShow = true;
      this.supplyShow = false;
      this.requisitionShow = false;
      //call project api
      this.http
        .request(
          'get',
          '/project/get-project-list/?is_active=True&show=All',
          null
        )
        .subscribe((res) => {
          // console.log('project user list', res);
          this.userList = res['data'];
          console.log('project user list', this.userList);
          console.log('jaosn data-->', JSON.stringify(this.userList[0]));
        });
    }
    if (val == 'supply') {
      this.userTypeValue = '';
      this.gcShow = false;
      this.lcShow = false;
      this.projectShow = false;
      this.supplyShow = true;
      this.requisitionShow = false;
      //call supply api
      this.http
        .request('get', '/supply/get/?is_active=True&show=All', null)
        .subscribe((res) => {
          console.log('supply user list', res);
          this.userList = res['data'].results;
          console.log('supply user list', this.userList);
          console.log('jaosn data-->', JSON.stringify(this.userList[0]));
        });
    }
    if (val == 'requisition') {
      this.userTypeValue = '';
      this.gcShow = false;
      this.lcShow = false;
      this.projectShow = false;
      this.supplyShow = false;
      this.requisitionShow = true;
      this.http
        .request('get', '/requisition/get/?is_active=True&show=All', null)
        .subscribe((res) => {
          console.log('requistion user list', res);
          this.userList = res['data'].results;
          console.log('requistion user list', this.userList);
          console.log('jaosn data-->', JSON.stringify(this.userList[0]));
        });
    }
  }

  // get analytics from api dasgbaord
  getAnalyticsCount() {
    this.http.request('get', '/dashboard/get-count/', null).subscribe((res) => {
      var Res = res;
      this.count = res.data;

      this.general_contractor_count = res.data['general_contractor_count'];
      this.project_count = res.data['project_count'];
      this.requisition_count = res.data['requisition_count'];
      this.requisition_labour_count = res.data['requisition_labour_count'];
      this.sub_contractor_count = res.data['sub_contractor_count'];
      this.supply_count = res.data['supply_count'];
      this.supply_labour_count = res.data['supply_labour_count'];
      this.user_count = res.data['user_count'];
    });
  }

  private _filter(value: string): string[] {
    const filterValue = value.toLowerCase();
    return this.userList.filter((option) =>
      option.toLowerCase().includes(filterValue)
    );
  }



  ///////////////////////
  // excel ts genrate
  ///////////////////////
  // export data into excel file
  exportAsXLSX(): void {
    this.excelService.exportAsExcelFile(this.userAnlyticsData, 'sample');

  }


}
